import {TSearchCustomerRequest} from "../../domain/repository/customer_repository";

interface IGetCustomerRequest {

    customerId?: string;

}
class GetCustomerRequest implements IGetCustomerRequest {

    public customerId: string;

}

interface IGetCustomersByClientTopPageRequest {

    searchCustomerRequest?: TSearchCustomerRequest;

}
class GetCustomersByClientTopPageRequest implements IGetCustomersByClientTopPageRequest {

    public searchCustomerRequest: TSearchCustomerRequest;
}

interface IGetAllExternalContractsByCustomerTopPageRequest {
}
class GetAllExternalContractsByCustomerTopPageRequest implements IGetAllExternalContractsByCustomerTopPageRequest {
}

interface IGetCustomersByPmCampaignPageRequest {
    pmCustomerIDs?: string[];
    toBPmCustomerIDs?: string[];
    toCPmCustomerIDs?: string[];
    bizdevPmCustomerIDs?: string[];
    growthPmCustomerIDs?: string[];
    pmmCustomerIDs?: string[];
    poCustomerIDs?: string[];
}

class GetCustomersByPmCampaignPageRequest implements IGetCustomersByPmCampaignPageRequest {
    public pmCustomerIDs: string[];
    public toBPmCustomerIDs: string[];
    public toCPmCustomerIDs: string[];
    public bizdevPmCustomerIDs: string[];
    public growthPmCustomerIDs: string[];
    public pmmCustomerIDs: string[];
    public poCustomerIDs: string[];
}

interface IGetCustomersBySalesCampaignPageRequest {
    salesStrategyCustomerIDs?: string[];
    cooCustomerIDs?: string[];
    kpiCustomerIDs?: string[];
    partnerSalesCustomerIDs?: string[];
    allianceCustomerIDs?: string[];
    salesOrgDevCustomerIDs?: string[];
    sfaCrmCustomerIDs?: string[];
    salesEnablementCustomerIDs?: string[];
    salesDxCustomerIDs?: string[];
    insideSalesCustomerIDs?: string[];
    customerSuccessCustomerIDs?: string[];
    ltvCustomerIDs?: string[];
    groupSalesCustomerIDs?: string[];
    interDeptCustomerIDs?: string[];
    crossSellCustomerIDs?: string[];
}

class GetCustomersBySalesCampaignPageRequest implements IGetCustomersBySalesCampaignPageRequest {
    public salesStrategyCustomerIDs: string[];
    public cooCustomerIDs: string[];
    public kpiCustomerIDs: string[];
    public partnerSalesCustomerIDs: string[];
    public allianceCustomerIDs: string[];
    public salesOrgDevCustomerIDs: string[];
    public sfaCrmCustomerIDs: string[];
    public salesEnablementCustomerIDs: string[];
    public salesDxCustomerIDs: string[];
    public insideSalesCustomerIDs: string[];
    public customerSuccessCustomerIDs: string[];
    public ltvCustomerIDs: string[];
    public groupSalesCustomerIDs: string[];
    public interDeptCustomerIDs: string[];
    public crossSellCustomerIDs: string[];
}

interface IGetCustomersByIpoCampaignPageRequest {
    ipoPrepCustomerIDs?: string[];
    internalControlCustomerIDs?: string[];
    auditCustomerIDs?: string[];
    securitiesAuditCustomerIDs?: string[];
    fundraisingCustomerIDs?: string[];
    irStrategyCustomerIDs?: string[];
    investorRelationsCustomerIDs?: string[];
    materialsCustomerIDs?: string[];
    globalCustomerIDs?: string[];
    cfoCustomerIDs?: string[];
}

class GetCustomersByIpoCampaignPageRequest implements IGetCustomersByIpoCampaignPageRequest {
    public ipoPrepCustomerIDs: string[];
    public internalControlCustomerIDs: string[];
    public auditCustomerIDs: string[];
    public securitiesAuditCustomerIDs: string[];
    public fundraisingCustomerIDs: string[];
    public irStrategyCustomerIDs: string[];
    public investorRelationsCustomerIDs: string[];
    public materialsCustomerIDs: string[];
    public globalCustomerIDs: string[];
    public cfoCustomerIDs: string[];
}

export {
    GetCustomerRequest,
    GetCustomersByClientTopPageRequest,
    GetAllExternalContractsByCustomerTopPageRequest,
    GetCustomersByPmCampaignPageRequest,
    GetCustomersBySalesCampaignPageRequest,
    GetCustomersByIpoCampaignPageRequest
}



// WEBPACK FOOTER //
// ./src/presentation/request/customer_request.ts